const SgiJsoneditorEO = function () {
    return {
        te: "jsoneditor组件",
        ctlH: '100%',
        ctlW: '100%',
        ctlN: "jsoneditor组件",
        desId: "EP_EO_UI_JSONEDITOR",
        mgn: "0 0 0 0",
        pad: "0 0 0 0",
    }
}
export { SgiJsoneditorEO };
export default SgiJsoneditorEO;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiJsoneditorEO.js